<template>
  <div class="pending-delivery">
    <SlListView
      @gotoPage="gotoPage"
      :total="page.total"
      :pageIndex="page.pageIndex"
      :pageSize="page.pageSize"
      :pageSizes="[50, 100, 200, 300, 400, 500]"
      @pageChange="handlePageChange"
    >
      <div solt="search">
        <SlSearchForm
          v-model="query"
          :items="searchItems"
          :loading="tableLoading"
          @reset="gotoPage(page.pageSize)"
          @search="gotoPage(page.pageSize)"
        ></SlSearchForm>

        <SlTableToolbar>
          <SlButton
            :disabled="multipleSelection.length === 0"
            type="primary"
            boxShadow="primary"
            @click="onDeliverGoods"
          >发货</SlButton>
          <SlButton
            type="primary"
            boxShadow="primary"
            @click="exportAwaitShipmentsList()"
            style="float: right"
          >导出</SlButton>
        </SlTableToolbar>
        <SlTableInfo
          :tableData="tableData"
          :columns="columns"
          :multiple="true"
          @selection-change="handleSelectionChange"
          headerAlign="left"
        ></SlTableInfo>
      </div>
    </SlListView>
    <ReissueDialog
      :show.sync="visible"
      :tableData="multipleSelection"
      @submited="gotoPage"
      :hidetable="false"
      :columns_returns="columns_returns"
    />

    <el-dialog
      title="返修附件"
      :visible.sync="qaDialogVisible"
      width="600px"
      @close="currentRow = null"
    >
      <div
        v-if="currentRow && currentRow.reviewAttachList && currentRow.reviewAttachList.length"
        style="display: flex; flex-wrap: wrap; gap: 20px"
      >
        <SlImage
          v-for="(url, idx) in currentRow.reviewAttachList"
          :key="idx"
          :src="url"
          size="8rem"
        />
      </div>
      <div v-else style="color: #999">暂无附件</div>
    </el-dialog>
  </div>
</template>

<script>
import OemGoodsAPI from '@api/oemGoods'
import ReissueDialog from './pendingReissue/ReissueDialog.vue'

export default {
  name: 'PendingReissue',
  components: {
    ReissueDialog
  },
  data () {
    return {
      page: {
        pageIndex: 1,
        pageSize: 100,
        total: 0
      },
      query: {},
      searchItems: [
        {
          type: 'batch-input',
          label: '生产订单号',
          name: 'purchaseOrderNumber'
        },
        {
          type: 'batch-input',
          label: 'SKU编码',
          name: 'skuCode'
        },
        {
          type: 'batch-input',
          label: 'UPC编码',
          name: 'upcs'
        },
        {
          type: 'input',
          label: '商品名称',
          name: 'commodityName'
        },
        {
          type: 'date',
          label: '下单日期',
          name: 'timeAts',
          data: {
            datetype: 'daterange',
            isBlock: true
          }
        }
      ],
      tableLoading: false,
      tableData: [],
      columns: [
        {
          name: 'purchaseOrderNumber',
          label: '生产订单号'
        },
        {
          name: 'warehouseName',
          label: '仓库'
        },
        {
          name: 'skuCode',
          label: 'SKU编码'
        },
        {
          name: 'upc',
          label: 'UPC编码'
        },
        {
          name: 'skuImage',
          label: '商品图片',
          isImage: true,
          data: {
            imgSize: '6rem'
          }
        }, {
          name: 'productName',
          label: '商品名称'
        }, {
          name: 'attributesName',
          label: '销售属性'
        }, {
          name: 'qualityNumber',
          label: '质检单号'
        }, {
          name: 'parentDeliveryOrderNumber',
          label: '源发货单号'
        }, {
          name: 'currencyName',
          label: '币种'
        }, {
          name: 'realPrice',
          label: '单价'
        }, {
          name: 'latestShelvedTime',
          label: '入库时间'
        }, {
          name: 'requireQuantity',
          label: '需返修数量'
        }, {
          name: 'reviewReason',
          label: '返修原因'
        }, {
          name: 'operation',
          label: '操作',
          render: (_h, { row }) => {
            return (
              <el-button type="text" onClick={() => this.openQaDialog(row)}>查看返修附件</el-button>
            )
          }
        }
      ],
      columns_returns: [],
      multipleSelection: [],
      // dialog
      visible: false,
      qaDialogVisible: false,
      currentRow: null
    }
  },
  created () {
    const pageSize = localStorage.getItem('oem_quality_returns_pageSize')
    if (pageSize) {
      this.page.pageSize = parseInt(pageSize)
    }
  },
  mounted () {
    let newarr = this.columns.slice()
    newarr.push({
      name: '_remark',
      width: 150,
      label: '备注'
    })
    this.columns_returns = newarr
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    handlePageChange (item) {
      localStorage.setItem('oem_quality_returns_pageSize', item.pageSize)
    },
    gotoPage (pageSize = 100, pageIndex = 1) {
      const params = this.generateParams(pageSize, pageIndex)
      this.tableLoading = true
      OemGoodsAPI.qualityRecheck(params).then(res => {
        if (res.success) {
          const data = res.data || {}
          this.tableData = data.list
          this.page.total = data.total
          this.page.pageIndex = pageIndex
          this.page.pageSize = pageSize
        }
      }).finally(() => {
        this.tableLoading = false
      })
    },
    generateParams (pageSize, pageIndex) {
      let { timeAts = [], ...orther } = this.query
      return {
        ...orther,
        pageIndex,
        pageSize,
        orderTimeStart: timeAts && timeAts[0] ? timeAts[0] : '',
        orderTimeEnd: timeAts && timeAts[1] ? timeAts[1] : ''
      }
    },
    generateExportParams () {
      let { timeAts = [], ...orther } = this.query
      return {
        ...orther,
        orderTimeStart: timeAts && timeAts[0] ? timeAts[0] : '',
        orderTimeEnd: timeAts && timeAts[1] ? timeAts[1] : ''
      }
    },
    onDeliverGoods () {
      if (!this.multipleSelection.length) {
        this.$message.warning('先选择SKU，再点击发货！')
      }
      this.visible = true
    },
    openQaDialog (row) {
      this.currentRow = row
      this.qaDialogVisible = true
    },
    exportAwaitShipmentsList () {
      const params = this.generateExportParams()
      this.tableLoading = true
      OemGoodsAPI.awaitRecheckExport(params).then(res => {
        const csvData = new Blob([res], { type: 'text/csv;charset=utf-8;' })
        const csvURL = window.URL.createObjectURL(csvData)
        const tempLink = document.createElement('a')
        tempLink.href = csvURL
        tempLink.setAttribute('download', '库内质检返修.csv')
        tempLink.click()
      }).finally(() => {
        this.tableLoading = false
      })
    }
  }
}
</script>
